import { useState } from "react";

const useRouteFilter = () => {
  const [filters, setFilters] = useState({
    search: "",
    status: null,
    tema: null,
    periodo: "hoje",
    ordem: "1",
    tipoCliente: null,
  });

  function cleanFilters(periodo) {
    setFilters({
      search: "",
      status: null,
      tema: null,
      periodo: "hoje",
      ordem: "1",
      tipoCliente: null,
    });
    periodo.upDateValue("hoje");
    periodo.upDateDefaultValue({ label: "Hoje", value: "hoje" });
  }

  return {
    filters,
    setFilters,
    cleanFilters,
  };
};

export default useRouteFilter;
